export default {
  linksExternos: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
